// extracted by mini-css-extract-plugin
module.exports = {"container":"technology_container__243hJ"};